import { useDispatch } from 'react-redux';

import { setDisplayMenu } from '@/redux/app/appSlice';

import menuImg from '@/images/menu.svg';

import s from './btnMenu.module.css';

function BtnMenu() {
  const dispatch = useDispatch();

  const displayMenu = () => dispatch(setDisplayMenu(true));

  return (
    <button
      type="button"
      onClick={displayMenu}
      className={s.btn_menu}
      title="menu"
    >
      <img src={menuImg} alt="menu" />
    </button>
  );
}

export default BtnMenu;
